<modal
  class="Modal"
  [config]="popUpModalConfig"
  [condition]="true"
  (cancel)="cancelDragAndDrop()"
>
  <div body>
    @if (errorResponse) {
      <h6
        class="Modal__Error"
        [innerHTML]="errorMessage"
        data-test-id="dragAndDropModalErrorMessage"
      ></h6>
    }
    <p
      [innerHTML]="dragAndDropModalConfig.body"
      data-test-id="dragAndDropModalBodyContent"
    ></p>
    <div
      cdkDropList
      class="DragContainer"
      (cdkDropListDropped)="resortColumn($event)"
    >
      @for (
        column of dragAndDropColumns;
        track column;
        let columnIndex = $index
      ) {
        <div class="DragColumn" cdkDrag>
          <div class="DragColumn__Icon">
            @if (column.isHidden || !column.prop) {
              <icon
                class="DragColumn__Icon--Disabled"
                [attr.aria-label]="'disabled drag icon button'"
                role="button"
                name="drag"
                label="Drag & Drop Disabled"
                [config]="{ fill: 'gray--shadow' }"
                data-test-id="'dragColumnDisabledIcon-' + columnIndex"
              >
              </icon>
            }
            <icon
              cdkDragHandle
              [attr.aria-label]="'drag icon button'"
              label="Drag & Drop"
              role="button"
              name="drag"
              data-test-id="'dragColumnIcon-' + columnIndex"
            ></icon>
          </div>
          <p
            [ngClass]="
              column.isHidden
                ? 'DragColumn__Content--Disabled'
                : 'DragColumn__Content'
            "
            [innerHTML]="column.name"
            data-test-id="'dragColumnName-' + columnIndex"
          ></p>
          @if (hidableField(column.prop)) {
            <div class="DragColumn__Action">
              <icon
                role="button"
                tabindex="0"
                [attr.aria-label]="getIconAriaLabel(column)"
                [name]="getIconName(column)"
                [label]="getIconLabel(column)"
                [config]="{ type: 'link' }"
                (click)="toggleShowHide(columnIndex)"
                data-test-id="'dragColumnActionIcon-' + columnIndex"
              ></icon>
              <p
                class="DragColumn__ActionContent"
                [innerHTML]="getActionContent(column)"
                data-test-id="'dragColumnActionContent-' + columnIndex"
              ></p>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <div footer class="u-flex u-alignCenter u-justifyBetween u-maxX">
    <zip-button
      [config]="dragAndDropModalConfig.cancelButton"
      (zipButtonClicked)="cancelDragAndDrop()"
      data-test-id="dragAndDropModalCancelButton"
    >
    </zip-button>
    <zip-button
      [config]="dragAndDropModalConfig.submitButton"
      (zipButtonClicked)="saveGridPreference()"
      data-test-id="dragAndDropModalSubmitButton"
    >
    </zip-button>
  </div>
</modal>
